import { createModule } from '@dynapp/wc-api-generic'

export default createModule({
  entitySingular: 'payment',
  entityPlural: 'payments',
  dataObject: 'dync-appshop-web',
  mode: process.env.NODE_ENV,
  state: {
    publishable: false
  }
});
